import React, { useEffect } from "react";
import InlineAuth from "../components/InlineAuth";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  return (
    <div className="auth-container" style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <InlineAuth />
    </div>
  );
}

